import { EProjectSection, trackEventV2 } from '../trackEventV2';
import {
  EGiftCardsEventName,
  EGroupBookingsEventName,
  IGiftCardsSelectedEvent,
  IGroupBookingsSelectedEvent,
} from './types';

export { EGiftCardsEventSource, EGroupBookingsEventSource } from './types';

export const trackGiftCardsSelectedEvent = (event: IGiftCardsSelectedEvent) => {
  trackEventV2(EGiftCardsEventName.GIFT_CARDS_SELECTED, EProjectSection.MARKETPLACE, { ...event });
};

export const trackGroupBookingsSelectedEvent = (event: IGroupBookingsSelectedEvent) => {
  trackEventV2(EGroupBookingsEventName.GROUP_BOOKINGS_SELECTED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};
